import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PerfilComponent } from '../components/perfil/perfil.component';
import { AuthService } from 'src/app/shared/services/auth.service';
import { SocketService } from 'src/app/shared/services/socket.service';
import { Notification } from '../models/notification.model';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent implements OnInit {
  public empresa: string = 'Nombre de la empresa';
  public opened = true;
  public darkMode = false;

  notificaciones: Notification[] = [];

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private authService: AuthService,
    private socketService: SocketService,
  ) {}

  ngOnInit() {
    this.empresa = 'Sachacabrona';
    // Leer el tema guardado en localStorage (si existe)
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      this.darkMode = savedTheme === 'dark';
      document.body.classList.add(this.darkMode ? 'dark-theme' : 'light-theme');
    } else {
      document.body.classList.add('light-theme');
    }

    this.socketService.connect();
    this.suscribirseASockets();
  }

  private suscribirseASockets(): void {
    this.socketService.nuevaOrden$.subscribe((res: Notification) => {
      this.notificaciones.unshift(res);
    });

    this.socketService.cambioEstadoPedido$.subscribe((res) => {
      console.log('Pedido actualizado');
    });
  }

  toggleSidenav() {
    this.opened = !this.opened;
  }

  toggleTheme() {
    this.darkMode = !this.darkMode;

    document.body.classList.remove('dark-theme', 'light-theme');
    document.body.classList.add(this.darkMode ? 'dark-theme' : 'light-theme');

    localStorage.setItem('theme', this.darkMode ? 'dark' : 'light');
  }

  irAMiPerfil() {
    this.dialog.open<PerfilComponent>(PerfilComponent, {
      disableClose: true,
      width: '700px',
      panelClass: 'perfil-dialog',
    });
  }

  cerrarSesion(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.authService.logout();
    this.router.navigate(['/admin/login']);
  }

  verNotificacion(n: any) {
    console.log('Notificación seleccionada:', n);
  }
}
